import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { motion, AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function Footer() {
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterStatus, setNewsletterStatus] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", content: "" });

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setNewsletterStatus(null);

    try {
      const res = await axios.post(`${apiUrl}/api/newsletter`, {
        email: newsletterEmail,
      });
      setNewsletterStatus({ success: true, message: res.data.message });
      setNewsletterEmail("");
      toast.success(res.data.message);
    } catch (err) {
      const msg = err.response?.data?.message || "Erreur lors de l'inscription.";
      setNewsletterStatus({ success: false, message: msg });
      toast.error(msg);
    }
  };

  const openModal = (title, content) => {
    setModalContent({ title, content });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800;900&family=Cormorant+Garamond:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600;700&display=swap');
        
        .footer {
          color: #2c1810;
          padding: 60px 20px 40px;
          font-family: 'Cormorant Garamond', serif;
          border-top: 1px solid rgba(212, 175, 55, 0.2);
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
        }

        .footer-container {
          max-width: 1200px;
          margin: auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 50px;
        }

        .footer-newsletter {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.2);
          border-radius: 20px;
          padding: 40px;
          margin: 0 auto 40px;
          text-align: center;
          max-width: 1000px;
          width: 90%;
        }

        .footer-newsletter h4 {
          font-size: 1.8rem;
          font-weight: 600;
          margin-bottom: 20px;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
        }

        .footer-newsletter p {
          font-size: 1.1rem;
          color: #5a4a3a;
          margin-bottom: 25px;
          font-family: 'Cormorant Garamond', serif;
        }

        .footer-col {
          flex: 1 1 250px;
        }

        .footer h4 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 25px;
          text-transform: uppercase;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
          letter-spacing: 1px;
        }

        .footer p,
        .footer a {
          font-size: 16px;
          color: #5a4a3a;
          line-height: 1.8;
          text-decoration: none;
          font-family: 'Cormorant Garamond', serif;
          transition: all 0.3s ease;
        }

        .footer a:hover {
          color: #d4af37;
          transform: translateX(5px);
        }

        .social-icons {
          display: flex;
          gap: 15px;
          margin-top: 15px;
        }

        .social-icons a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: rgba(212, 175, 55, 0.2);
          border-radius: 50%;
          color: #2c1810;
          font-size: 16px;
          transition: all 0.3s ease;
          border: 1px solid rgba(212, 175, 55, 0.3);
          backdrop-filter: blur(10px);
        }

        .social-icons a:hover {
          background: rgba(212, 175, 55, 0.3);
          color: #2c1810;
          transform: translateY(-3px);
          box-shadow: 0 4px 16px rgba(212, 175, 55, 0.3);
        }

        .footer-bottom {
          margin-top: 40px;
          text-align: center;
          font-size: 14px;
          color: #5a4a3a;
          border-top: 1px solid rgba(212, 175, 55, 0.2);
          padding-top: 20px;
          font-family: 'Cormorant Garamond', serif;
        }

        .newsletter-form {
          display: flex;
          max-width: 400px;
          margin: 20px auto 0;
          border-radius: 15px;
          overflow: hidden;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        }

        .newsletter-form input {
          flex: 1;
          padding: 12px 16px;
          border: 1px solid rgba(212, 175, 55, 0.2);
          border-radius: 15px 0 0 15px;
          font-size: 16px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
          transition: all 0.3s ease;
        }

        .newsletter-form input:focus {
          outline: none;
          border-color: #d4af37;
          background: rgba(255, 255, 255, 0.15);
          box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.1);
        }

        .newsletter-form input::placeholder {
          color: #5a4a3a;
          font-family: 'Cormorant Garamond', serif;
        }

        .newsletter-form button {
          padding: 12px 20px;
          background: rgba(212, 175, 55, 0.2);
          color: #2c1810;
          font-weight: 600;
          border: 1px solid rgba(212, 175, 55, 0.3);
          border-radius: 0 15px 15px 0;
          cursor: pointer;
          font-family: 'Cormorant Garamond', serif;
          text-transform: uppercase;
          font-size: 14px;
          letter-spacing: 0.5px;
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
        }

        @media (max-width: 768px) {
          .newsletter-form button {
            font-size: 11px;
          }
        }

        .newsletter-form button:hover {
          background: rgba(212, 175, 55, 0.3);
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(212, 175, 55, 0.3);
        }

        .newsletter-status {
          font-size: 14px;
          margin-top: 12px;
          font-family: 'Cormorant Garamond', serif;
        }

        @media (max-width: 768px) {
          .footer-container {
            flex-direction: column;
            gap: 40px;
            text-align: center;
            align-items: center;
          }
          
          .footer-col {
            flex: 1 1 100%;
            text-align: center;
          }
          
          .newsletter-form {
            max-width: 100%;
          }

          .footer-newsletter {
            padding: 30px 20px;
            margin-bottom: 30px;
            width: 95%;
          }

          .social-icons {
            justify-content: center;
          }

          .footer h4 {
            text-align: center;
          }

          .footer p,
          .footer a {
            text-align: center;
          }
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          backdrop-filter: blur(5px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 20px;
        }

        .modal-content {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.3);
          border-radius: 20px;
          padding: 40px;
          max-width: 600px;
          width: 100%;
          max-height: 80vh;
          overflow-y: auto;
          position: relative;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          padding-bottom: 15px;
          border-bottom: 1px solid rgba(212, 175, 55, 0.2);
        }

        .modal-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
        }

        .modal-close {
          background: none;
          border: none;
          font-size: 1.2rem;
          color: #5a4a3a;
          cursor: pointer;
          padding: 5px;
          border-radius: 50%;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 35px;
          height: 35px;
        }

        .modal-close:hover {
          background: rgba(212, 175, 55, 0.1);
          color: #2c1810;
        }

        .modal-body {
          font-size: 1rem;
          line-height: 1.6;
          color: #5a4a3a;
          font-family: 'Cormorant Garamond', serif;
        }

        .modal-body h3 {
          color: #2c1810;
          font-weight: 600;
          margin: 20px 0 10px 0;
          font-size: 1.2rem;
        }

        .modal-body p {
          margin-bottom: 15px;
        }

        .modal-body ul {
          margin: 15px 0;
          padding-left: 20px;
        }

        .modal-body li {
          margin-bottom: 8px;
        }
      `}</style>

      <footer className="footer">
        {/* Newsletter en haut */}
        <div className="footer-newsletter">
          <h4>S'inscrire à la newsletter</h4>
          <p>Recevez nos nouveautés et promotions</p>
          <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
            <input
              type="email"
              placeholder="Saisissez l'adresse..."
              value={newsletterEmail}
              onChange={(e) => setNewsletterEmail(e.target.value)}
              required
            />
            <button type="submit">S'inscrire</button>
          </form>
          {newsletterStatus && (
            <p
              className="newsletter-status"
              style={{ color: newsletterStatus.success ? "green" : "red" }}
            >
              {newsletterStatus.message}
            </p>
          )}
        </div>

        <div className="footer-container">
          <div className="footer-col">
            <h4>Contact</h4>
            <p>Email : <a href="mailto:safastep@gmail.com">safastep@gmail.com</a></p>
            <p>Téléphone : <br />+212 706-696865</p>
            <div className="social-icons">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/safa.step?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://vm.tiktok.com/ZMSWhaDSQ/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
              >
                <i className="fab fa-tiktok"></i>
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Menu principal</h4>
            <p><Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Accueil</Link></p>
            <p><button 
              onClick={() => {
                const section = document.querySelector('.section-containers');
                if (section) {
                  const rect = section.getBoundingClientRect();
                  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                  const targetPosition = scrollTop + rect.top - 180;
                  window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                }
              }}
              style={{
                background: 'none',
                border: 'none',
                color: '#5a4a3a',
                cursor: 'pointer',
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '16px',
                padding: '0',
                transition: 'all 0.3s ease'
              }}
            >Produits</button></p>
            <p><Link to="/products/collections-speciales">Nouvelle Collection</Link></p>
            <p><Link to="/guide-tailles">Guide de Taille</Link></p>
            <p><Link to="/conseils">Conseils d'entretien</Link></p>
          </div>

          <div className="footer-col">
            <h4>TERMES ET POLITIQUES</h4>
            <p><button 
              onClick={() => openModal("Conditions Générales", `
                <h3>Conditions Générales de Vente</h3>
                <p>Les présentes conditions générales de vente s'appliquent à toutes les commandes passées sur le site SAFA Store.</p>
                
                <h3>1. Produits</h3>
                <p>Nos babouches sont fabriquées artisanalement au Maroc avec des matériaux naturels de qualité.</p>
                
                <h3>2. Commandes</h3>
                <p>Les commandes sont traitées dans les 24h suivant leur réception. Un email de confirmation vous sera envoyé.</p>
                
                <h3>3. Prix</h3>
                <p>Tous nos prix sont exprimés en MAD (Dirhams Marocains) et incluent la TVA applicable.</p>
                
                <h3>4. Livraison</h3>
                <p>La livraison est gratuite partout au Maroc. Les délais de livraison sont de 24h à 48h.</p>
                
                <h3>5. Paiement</h3>
                <p>Le paiement s'effectue à la livraison après essayage des produits.</p>
              `)}
              style={{
                background: 'none',
                border: 'none',
                color: '#5a4a3a',
                cursor: 'pointer',
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '16px',
                padding: '0',
                transition: 'all 0.3s ease'
              }}
            >Conditions Générales</button></p>
            <p><button 
              onClick={() => openModal("Politique d'expédition", `
                <h3>Politique d'Expédition</h3>
                <p>Nous nous engageons à expédier vos commandes dans les meilleures conditions possibles.</p>
                
                <h3>Délais d'Expédition</h3>
                <ul>
                  <li>Commandes passées avant 14h : expédition le jour même</li>
                  <li>Commandes passées après 14h : expédition le lendemain</li>
                  <li>Délai de livraison : 24h à 48h partout au Maroc</li>
                </ul>
                
                <h3>Frais de Livraison</h3>
                <p>La livraison est entièrement gratuite pour toutes les commandes, quel que soit le montant.</p>
                
                <h3>Suivi de Commande</h3>
                <p>Un numéro de suivi vous sera communiqué par SMS dès l'expédition de votre commande.</p>
                
                <h3>Zones de Livraison</h3>
                <p>Nous livrons dans toutes les villes du Maroc, y compris les zones rurales.</p>
              `)}
              style={{
                background: 'none',
                border: 'none',
                color: '#5a4a3a',
                cursor: 'pointer',
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '16px',
                padding: '0',
                transition: 'all 0.3s ease'
              }}
            >Politique d'expédition</button></p>
            <p><button 
              onClick={() => openModal("Retour et échange", `
                <h3>Politique de Retour et Échange</h3>
                <p>Votre satisfaction est notre priorité. Nous acceptons les retours et échanges dans certaines conditions.</p>
                
                <h3>Conditions de Retour</h3>
                <ul>
                  <li>Produit non utilisé et dans son état d'origine</li>
                  <li>Emballage d'origine intact</li>
                  <li>Retour sous 14 jours après réception</li>
                </ul>
                
                <h3>Motifs de Retour Acceptés</h3>
                <ul>
                  <li>Erreur de taille ou de couleur</li>
                  <li>Défaut de fabrication</li>
                  <li>Produit endommagé lors de la livraison</li>
                </ul>
                
                <h3>Procédure de Retour</h3>
                <p>Contactez notre service client par WhatsApp ou email pour initier un retour. Nous vous guiderons dans la procédure.</p>
                
                <h3>Remboursement</h3>
                <p>Le remboursement sera effectué dans les 7 jours ouvrables suivant la réception du retour.</p>
              `)}
              style={{
                background: 'none',
                border: 'none',
                color: '#5a4a3a',
                cursor: 'pointer',
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '16px',
                padding: '0',
                transition: 'all 0.3s ease'
              }}
            >Retour et échange</button></p>
            <p><button 
              onClick={() => openModal("Avis légal", `
                <h3>Avis Légal</h3>
                <p>SAFA Store est une marque déposée et protégée par les lois marocaines sur la propriété intellectuelle.</p>
                
                <h3>Propriété Intellectuelle</h3>
                <p>Tous les éléments du site (textes, images, logos, design) sont la propriété exclusive de SAFA Store.</p>
                
                <h3>Utilisation du Site</h3>
                <p>L'utilisation de ce site est réservée à un usage personnel et non commercial.</p>
                
                <h3>Responsabilité</h3>
                <p>SAFA Store s'efforce de fournir des informations exactes mais ne peut garantir l'absence d'erreurs.</p>
                
                <h3>Droit Applicable</h3>
                <p>Les présentes conditions sont régies par le droit marocain. Tout litige sera soumis aux tribunaux marocains.</p>
                
                <h3>Contact Légal</h3>
                <p>Pour toute question juridique : safastep@gmail.com</p>
              `)}
              style={{
                background: 'none',
                border: 'none',
                color: '#5a4a3a',
                cursor: 'pointer',
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '16px',
                padding: '0',
                transition: 'all 0.3s ease'
              }}
            >Avis légal</button></p>
            <p><button 
              onClick={() => openModal("Cookies", `
                <h3>Politique des Cookies</h3>
                <p>Ce site utilise des cookies pour améliorer votre expérience de navigation.</p>
                
                <h3>Types de Cookies Utilisés</h3>
                <ul>
                  <li><strong>Cookies techniques :</strong> Nécessaires au fonctionnement du site</li>
                  <li><strong>Cookies analytiques :</strong> Pour analyser l'utilisation du site</li>
                  <li><strong>Cookies de préférences :</strong> Pour mémoriser vos choix</li>
                </ul>
                
                <h3>Gestion des Cookies</h3>
                <p>Vous pouvez désactiver les cookies dans les paramètres de votre navigateur, mais cela peut affecter le fonctionnement du site.</p>
                
                <h3>Cookies Tiers</h3>
                <p>Nous utilisons des services tiers (Google Analytics) qui peuvent placer des cookies sur votre appareil.</p>
                
                <h3>Conservation</h3>
                <p>Les cookies sont conservés pour une durée maximale de 13 mois conformément à la réglementation.</p>
                
                <h3>Vos Droits</h3>
                <p>Vous avez le droit de refuser les cookies non essentiels et de les supprimer à tout moment.</p>
              `)}
              style={{
                background: 'none',
                border: 'none',
                color: '#5a4a3a',
                cursor: 'pointer',
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '16px',
                padding: '0',
                transition: 'all 0.3s ease'
              }}
            >Cookies</button></p>
          </div>
        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} SafaStep. Tous droits réservés. Réalisé par <a 
            href="https://kyboho.vercel.app/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              color: '#d4af37',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#2c1810';
              e.target.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = '#d4af37';
              e.target.style.textDecoration = 'none';
            }}
          >
            KYBOHO
          </a>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence>
        {showModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="modal-overlay"
            onClick={closeModal}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <h2 className="modal-title">{modalContent.title}</h2>
                <button className="modal-close" onClick={closeModal}>
                  <FaTimes />
                </button>
              </div>
              <div 
                className="modal-body"
                dangerouslySetInnerHTML={{ __html: modalContent.content }}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
